// Angular
import { bootstrapApplication } from "@angular/platform-browser";

// Components
import { AppComponent } from "#src/app/app.component";

// Configs
import { appConfig } from "#src/app/app.config";

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
